var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E2F1FC","fillRule":"evenodd","d":"M124 0v87h50.857c0 27.45-22.777 49.714-50.857 49.714V174c49.156 0 89-38.948 89-87V0h-89zM0 87h50.857c0 27.45-22.777 49.714-50.857 49.714V174c49.156 0 89-38.948 89-87V0H0v87z"}));
}

Quote.defaultProps = {"width":"213","height":"174","viewBox":"0 0 213 174"};

module.exports = Quote;

Quote.default = Quote;
